<template>
  <div :class="['rounded-b-lg px-4 mb-4 md:mb-16']">
    <div class="w-full mx-auto pb-4">
      <div
        :class="[
          'pr-4 pl-4 pt-1 pb-1 rounded ml-4 mr-4 mb-2  text-center flex justify-center items-center',
        ]"
      >
        <svg
          class="mr-1"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#4A5568"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {{ lang["select_day"][language] }}
      </div>
      <div
        v-if="
          this.menu.enable_free_timeslots &&
          this.menu.timeslots_mode == 'individual'
        "
      >
        <div>
          <div
            v-if="menu.is_asap_enabled"
            @click="changeDate('asap')"
          >
            <div
              :class="[
                'w-full h-10 mt-2 rounded flex items-center justify-center text-center text-sm rounded-large shadow-lg transition duration-500  hover:shadow-xl',
                selectedDate == 'asap'
                  ? 'transition duration-500 bg-gray-400'
                  : '',
              ]"
            >
               {{ lang['as_soon_as_possible'][this.language]}}
            </div>
          </div>
          <div
            v-for="timeSlot in $_.groupBy(timeSlots, 'date')"
            :key="timeSlot.date + timeSlot.start_time"
            @click="changeDate(timeSlot[0].date)"
          >
            <div
              :class="[
                'w-full h-10 mt-2 rounded flex items-center justify-center text-center text-sm rounded-large shadow-lg transition duration-500  hover:shadow-xl',
                selectedDate == timeSlot[0].date
                  ? 'transition duration-500 bg-gray-400'
                  : '',
              ]"
            >
              {{ timeSlot[0].date }}
            </div>
          </div>
        </div>
        <div
          v-show="selectedDate"
          :class="[
            'pr-4 pl-4 pt-1 pb-1 rounded ml-4 mr-4 mb-2 text-center flex justify-center items-center',
          ]"
        >
          <svg
            class="mr-1"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="#4A5568"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div
            v-show="
              !['','asap'].includes(selectedDate) &&
              $_.size(
                $_.filter(timeSlots, function (timeSlot) {
                  return timeSlot.date == selectedDate;
                })
              ) > 0
            "
          >
            {{ lang["select_time_slot"][language] }}
          </div>
          <div
            v-show="
              !['','asap'].includes(selectedDate) &&
              $_.size(
                $_.filter(timeSlots, function (timeSlot) {
                  return timeSlot.date == selectedDate;
                })
              ) == 0
            "
          >
            {{ lang["no_time_slots"][language] }}
          </div>
        </div>
        <div v-show="selectedDate">
          <div
            v-for="timeSlot in $_.orderBy(
              $_.filter(timeSlots, function (timeSlot) {
                return timeSlot.date == selectedDate;
              })
            )"
            :key="timeSlot.date + timeSlot.start_time"
            :class="[
              selectedTimeSlot == `${timeSlot.date} ${timeSlot.start_time}`
                ? 'shadow-lg transition duration-500  hover:shadow-xl bg-gray-400'
                : '',
              'w-full h-10 mt-2 rounded flex items-center justify-center rounded-large shadow-lg transition duration-500  hover:shadow-xl',
            ]"
            @click="
              selectedTimeSlot = `${timeSlot.date} ${timeSlot.start_time}`
            "
          >
            {{ timeSlot.start_time.substring(0, 5) }}
          </div>
        </div>
      </div>
      <div v-else>
        <div class="flex flex-col w-full border-1.5 voor rounded-xl">
          <div
            v-if="menu.is_asap_enabled"
            class="border-b-2 borderNone borderRadius font-semibold achter cursor-pointer"
            :class="[
              'transition duration-500',
                selectedDate == `asap`? 'text-new-primary bg-primary-100 cursor-not-allowed'
                : '',
              'h-12 pl-3 flex items-center text-sm text-gray-600',
              
            ]"
            :style="
              selectedDate == `asap`
                ? timeslotActiveBackground + ' ' + timeslotActiveColor
                : ''
            "
            @click="changeDate('asap')"

          >
            <div class="flex justify-center w-full">
              <p >
               {{ lang['as_soon_as_possible'][this.language]}}
              </p>
            </div>
          </div>
          <div
            v-for="(date, index) in $_.filter(
              fullDates,
              function (date, index) {
                return index < totalDaysVisible;
              }
            )"
            class="border-b-2 borderNone borderRadius font-semibold achter cursor-pointer"
            :class="[
              'transition duration-500 h-12 pl-3 flex items-center text-sm',
              selectedDate == `${date.fullDate}`
                ? 
                  /* theme.body.selectedBackgroundColor*/ 'bg-primary-100 text-red-500' +
                  /* theme.body.selectedTextColor */ 'text-new-primary'
                : '',
              $_.size(
                $_.filter(timeSlots, function (timeSlot) {
                  return timeSlot.date == date.fullDate;
                })
              ) > 0
                ? 'text-gray-600'
                : 'bg-gray-600 text-white opacity-50 cursor-not-allowed',
            ]"
            :style="
              selectedDate == `${date.fullDate}`
                ? timeslotActiveBackground + ' ' + timeslotActiveColor
                : ''
            "
            :key="index"
            @click="changeDate(date.fullDate)"
          >
            <div class="flex justify-center w-full">
              <p class="mr-2">{{ date.dayInText }}</p>
              <p>{{ date.date }}.</p>
            </div>
          </div>
        </div>
        <!-- knop more days -->
        <div class="flex justify-center" v-if="menu.max_timesl_days > 3">
          <div
            v-if="loadMoreDaysVisible"
            class="mt-6 mb-6 p-2 w-32 h-8 flex items-center justify-around bg-gray-300 text-sm text-new-primary font-semibold rounded-large"
            @click="showAllDates"
          >
            {{ lang["meer_dagen"][language] }}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="w-4 h-4 transform transition duration-300"
            >
              <path
                d="M19 9l-7 7-7-7"
                fill="none"
                stroke="#9D9D9D"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div
            v-else
            class="mt-6 mb-6 p-2 w-32 h-8 flex items-center justify-around bg-gray-300 text-sm text-new-primary font-semibold rounded-large"
            @click="showLessDates"
          >
            {{ lang["minder_dagen"][language] }}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="w-4 h-4 transform rotate-180 transition duration-300"
            >
              <path
                d="M19 9l-7 7-7-7"
                fill="none"
                stroke="#9D9D9D"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div class="w-full justify-center">
          <SkeletonLoader v-if="loading" type="timeslot" :count="10" />

          <div v-else v-show="!['','asap'].includes(selectedDate)">
            <div
              :class="[
                'pr-4 pl-4 pt-1 pb-1 rounded ml-4 mr-4 mb-2 text-center flex justify-center items-center',
              ]"
            >
              <svg
                class="mr-1"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="#4A5568"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div
                ref="targetTimeslot"
                v-show="
                  !['','asap'].includes(selectedDate) &&
                  $_.size(
                    $_.filter(timeSlots, function (timeSlot) {
                      return timeSlot.date == selectedDate;
                    })
                  ) > 0
                "
              >
                {{ lang["select_time_slot"][language] }}
              </div>
              <div
                v-show="
                  !['','asap'].includes(selectedDate) &&
                  $_.size(
                    $_.filter(timeSlots, function (timeSlot) {
                      return timeSlot.date == selectedDate;
                    })
                  ) == 0
                "
              >
                {{ lang["no_time_slots"][language] }}
              </div>
            </div>
            <div class="border-1.5 rounded-xl">
              <div
                v-for="timeSlot in $_.orderBy(
                  $_.filter(timeSlots, function (timeSlot) {
                    return timeSlot.date == selectedDate;
                  }),
                  (timeslot) => timeslot.start_time
                )"
                :key="timeSlot.date + timeSlot.start_time"
                :class="[
                  '',
                  selectedTimeSlot == `${timeSlot.date} ${timeSlot.start_time}`
                    ? 'transition duration-500 ' +
                      /* theme.body.selectedBackgroundColor */ 'bg-primary-100 text-black' +
                      ' ' +
                      /* theme.body.selectedTextColor */ 'text-black'
                    : '',
                  'w-full h-12 rounded flex font-semibold borderRadius items-center pl-3 borderNone border-b-1.5 transition duration-500 text-product-gray rounded-md justify-center',
                ]"
                :style="
                  selectedTimeSlot == `${timeSlot.date} ${timeSlot.start_time}`
                    ? timeslotActiveBackground + ' ' + timeslotActiveColor
                    : ''
                "
                @click="
                  selectedTimeSlot = `${timeSlot.date} ${timeSlot.start_time}`
                "
              >
                <p>
                  {{ timeSlot.start_time.substring(0, 5) }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div :class="colors">
      <FloatingCartInfo />
    </div> -->
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
import SkeletonLoader from "../components/SkeletonLoaders/SkeletonLoader.vue";
import moment from "moment";
export default {
  components: { SkeletonLoader },
  data() {
    return {
      lang: lang,
      loading: false,
      selectedDate: "",
      totalDaysVisible: 3,
      fullDates: [],
      moment:moment,
      loadMoreDaysVisible: true,
    };
  },
  computed: {
    ...mapGetters(["language", "theme", "menu"]),
    ...mapGetters("Cart", ["timeSlots", "selectedTimeSlot","isTimeSlotsLoading"]),
    ...mapGetters("Theme", ["timeslotActiveBackground", "timeslotActiveColor"]),
    // if we already know the timeslots we fill it in, we also keep listening to the value . If it changes, store them in de cookies and vuexx
    selectedTimeSlot: {
      get() {
        return this.$store.getters["Cart/selectedTimeSlot"];
      },
      set(value) {
        this.$store.commit("Cart/updateSelectedTimeSlot", value);
      },
    },
  },
  mounted() {
    // get the timeslots from the back-end
    if (!this.isTimeSlotsLoading && !this.timeSlots.length) {
    this.loading = true;
      this.$store
        .dispatch("Cart/GET_TIME_SLOTS")
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status == 404) {
            this.loading = false;
            this.$router.go(-3);
          }
        });
    }
    // format the date
    for (let i = 0; i < this.menu.max_timesl_days; i++) {
      let date = { date: "", dayInText: "", fullDate: "" };
      date.dayInText = moment()
        .lang(this.language)
        .add(i, "days")
        .format("dddd");
      date.date = moment().lang(this.language).add(i, "days").format("Do MMM");
      date.fullDate = moment().add(i, "days").format().substring(0, 10);
      this.fullDates.push(date);
    }

    this.selectedDate = this.selectedTimeSlot.substring(0, 10);
  },
  updated() {
    // Calculation to know if the 'more days tab' needs to be open or not.
    if (
      !["","asap"].includes(this.selectedDate)  &&
      moment(this.selectedDate).subtract(3, "days").calendar("do MMM") >=
        moment().calendar("do MMM")
    ) {
      this.showAllDates();
    }
    // check if you can continue ti the next step or not
    if (this.selectedTimeSlot) {
      this.$store.commit("updateIsCickable", "");
    } else {
      this.$store.commit("updateIsCickable", "opacity-40 cursor-not-allowed");
    }
  },
  methods: {
    changeDate(value) {
      this.selectedDate = value;
      this.selectedTimeSlot = "";
      if (value=='asap') {
        this.selectedTimeSlot = value
      }
      // Automatically scroll down to the times when selecting a day in the timeslots
      this.$nextTick(() => {
        const element = this.$refs.targetTimeslot;
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      });
    },
    showAllDates() {
      if (
        this.enable_free_timeslots &&
        this.menu.timeslots_mode == "individual"
      ) {
        this.totalDaysVisible = 365;
      } else {
        this.totalDaysVisible = this.menu.max_timesl_days;
      }
      this.loadMoreDaysVisible = false;
    },
    showLessDates() {
      this.totalDaysVisible = 3;
      this.loadMoreDaysVisible = true;
    },
  },
};
</script>

<style scoped>
.borderNone:last-of-type {
  border: none;
}
.borderRadius:last-of-type {
  border-radius: 0 0 10px 10px;
}

.borderRadius:first-of-type {
  border-radius: 10px 10px 0 0;
}

.input + div {
  transition: all 0.3s;
}

.input + div img {
  transition: all 0.3s;
}

.input:checked + div img {
  transform: rotate(45deg);
}

.input:checked + div {
  background: #e7e7e7;
  opacity: 1;
}
</style>
